import { createSlice } from '@reduxjs/toolkit'

import { setOverageLimit } from 'common/billing/actions/overagesActions'

export interface OveragesManagingModalState {
  isOpen: boolean
  loading: boolean
}

const initialState = {
  isOpen: false,
  loading: false,
}

export const overagesManagingModalSlice = createSlice({
  name: 'overagesManagingModal',
  initialState,
  reducers: {
    open: (state: OveragesManagingModalState) => {
      state.isOpen = true
    },
    close: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(setOverageLimit.pending, (state) => {
        state.loading = true
      })
      .addCase(setOverageLimit.fulfilled, () => ({ ...initialState }))
      .addCase(setOverageLimit.rejected, (state) => {
        state.loading = false
      })
  },
})

export const overagesManagingModalActions = overagesManagingModalSlice.actions
